module.exports = __webpack_public_path__ + "img/JV.fbbd1b9b.png";